import { useFormContext } from 'react-hook-form';

import { ReferenceField, SolutionField } from '../../components';
import { CognitiveDomainField } from '../cognitive-domain-field';
import { LearningObjectiveStatementField } from '../learning-objective-statement-field';
import type { SingleQuestionCreationFormInput } from '../single-question-creation-form';

interface PropertiesFormSectionProps {
  questionId?: string;
  taskId: string;
}

export default function PropertiesFormSection(props: Readonly<PropertiesFormSectionProps>) {
  const { questionId, taskId } = props;

  const { watch } =
    useFormContext<Pick<SingleQuestionCreationFormInput, 'location' | 'properties'>>();
  const cognitive = watch('properties.cognitiveDomain') ?? [];
  const chapterLevelItemId = watch('location.CHAPTER.value') ?? null;

  return (
    <>
      <CognitiveDomainField
        name='properties.cognitiveDomain'
        placeholder={
          cognitive.length === 0 ? 'กรุณาเลือกคุณลักษณะของข้อสอบ (Cognitive Domain)' : undefined
        }
      />
      <LearningObjectiveStatementField
        name='properties.learningObjectiveStatement'
        chapterLevelItemId={chapterLevelItemId}
        required
      />
      <SolutionField name='properties.solution' questionId={questionId} taskId={taskId} required />
      <ReferenceField
        name='properties.reference'
        questionId={questionId}
        taskId={taskId}
        required
      />
    </>
  );
}
